// extracted by mini-css-extract-plugin
export var aircallIframe = "_j2-3";
export var fabContainer = "_j2-5";
export var fabRinging = "_j2-6";
export var loadingOverlay = "_j2-4";
export var pulse = "_j2-7";
export var widgetContent = "_j2-2";
export var widgetPanel = "_j2-0";
export var widgetPanelExpanded = "_j2-1";